export default {
	countDays: function(year) {
		return (new Date(year, 11, 31).getTime() - new Date(year, 0, 1).getTime()) / (24 * 60 * 60000) + 1;
	},

	//周算法：如果一年中最后一天所在的周跨年了，则该周属于上一年最后一周
	countWeeks: function(year) {
		year = parseInt(year);
	    
		if(!year || isNaN(year)) {
			year = new Date().getFullYear();
		}
		//第一天是星期几
	    let firstDayOfThisYear = year + '-01-01';
	    let day = new Date(firstDayOfThisYear).getDay();
	    let totalDays = this.countDays(year);
	    totalDays -= day;
	    return parseInt(totalDays / 7) + (totalDays % 7 > 0? 1 : 0);
	},
	
	getWeekString: function(date) {
	    if (!date) {
	        date = new Date();
	    }
	    date = new Date(date);
	    let year = date.getFullYear();
	    let firstDayOfThisYear = year + '-01-01';
	    let firstDayDayValue = new Date(firstDayOfThisYear).getDay();
	    	
	    let dayIndexInThisYear = parseInt((date.getTime() - new Date(year, 0, 1).getTime()) / (24 * 60 * 60000));
	    let weekIndex = parseInt((dayIndexInThisYear - firstDayDayValue) / 7) + 1;

	    if(weekIndex < 10) {
	    	weekIndex = '0' + weekIndex.toString();
	    }

	    return year.toString() + weekIndex.toString();
	},

	getStartDateByWeek: function(week) {
		if (!week) {
	        return '';
	    }

	    if (typeof week === 'string') {
	        week = parseInt(week);
	    }

	    let year = Math.floor(week / 100);
	    let w = week % 100;
	    let weekDate = new Date(year, 0, 1);

	    weekDate.setDate((w - 1) * 7 + 1 - weekDate.getDay());
	    
	    return weekDate;
	},
	
	getNextWeek: function(week) {
	    if (typeof week === 'string') {
	        week = week.replace(/-/g, '');
	        week = parseInt(week);
	    }
	    var year = Math.floor(week / 100);
	    var w = week % 100;
	    if (w < 52) {
	        return year * 100 + w + 1;
	    } 
	    if (w == 53) {
	        return (year + 1) * 100 + 1;
	    } 
	 
	    if (this.countWeeks(year) == 52) {
	        return (year + 1) * 100 + 1;
	    } 

	    return year * 100 + w + 1;
	},

	getLastWeek: function(week) {
		if (typeof week === 'string') {
	        week = week.replace(/-/g, '');
	        week = parseInt(week);
	    }
	    var year = Math.floor(week / 100);
	    var w = week % 100;
	    if (w > 1) {
	        return year * 100 + w - 1;
	    } 
	    else {
	    	return (year - 1) * 100 + this.countWeeks(year - 1)
	    }
	}
}



// WEBPACK FOOTER //
// ./src/js/week.js